export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  // user info
  userId: '',
  token: '',
  roleType: 0, // 管理者的角色：店家管理者(10)、品牌管理者(30)、POS管理者(50)、代理商管理者(60)、平台管理者(99)
  account: '',
  authError: '', // checkToken 失敗時要顯示的訊息
  brandId: '',
  brands: [], // 品牌列表
  storeId: '',
  storeInfo: {},
  stores: [], // 門市列表
  // update schedule
  menuStartTime: '',
  menuEndTime: '',
  // update data
  upCategory: false,
  upAdjust: false,
  // modal open
  modal: false,
  // lineNotify table
  selRoleType: 'admin',
  selManagerId: 1,
  modalView: false,
  // black reason
  blackReason: [],
  // 取餐方式
  pickupList: [1, 2, 3, 4, 5, 21],
  // notify
  unReadNotify: 0,
  tradeType: [],
  restrictedList: [],
  denyList: [],
  // 縣市列表
  cityList: [],
  // 你訂聯盟
  nidin_league: 0
}



// WEBPACK FOOTER //
// ./src/store/state.js